import Auth from '@aws-amplify/auth';
import { JS } from '@aws-amplify/core';
import { Alert, Button, LinkButton, Spinner } from '@salecycle/ui-component-library';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import LoginFormHeader from './loginFormHeader';
import PasswordStrength from './passwordStrength';
import { AlertContainer, SubmitContainer, SubmitButtonContainer } from './styles';

export interface IState {
  errorMessage: string;
  newPassword: string;
  submitButtonDisabled: boolean;
}

export interface Props {
  changeState: (state: any, data?: any, emailAddress?: string) => void;
  authData: any;
}

export const VerifyUser: FC<Props> = props => {
  const { t } = useTranslation('login');
  const [isLoading, setIsLoading] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState('');
  const [newPassword, setNewPassword] = React.useState('');
  const [submitButtonDisabled, setSubmitButtonDisabled] = React.useState(true);
  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      const data = props.authData;
      const completedUser = await Auth.completeNewPassword(data, newPassword, Attr);
      if (completedUser.challengeName === 'MFA_SETUP') {
        props.changeState('TOTPSetup', completedUser);
      } else {
        checkContact(completedUser);
      }
    } catch (err) {
      if (err instanceof Error) setErrorMessage(err.message);
    }
    setIsLoading(false);
  };

  const checkContact = (user: any) => {
    if (!Auth || typeof Auth.verifiedContact !== 'function') {
      throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
    }
    Auth.verifiedContact(user).then(data => {
      if (!JS.isEmpty(data.verified)) {
        props.changeState('signedIn', user);
      } else {
        user = Object.assign(user, data);
        props.changeState('verifyContact', user);
      }
    });
  };

  const handleBackToSignIn = () => {
    props.changeState('signIn');
  };

  const handleFormChange = (strength: any, password: string) => {
    if (strength === 5) {
      setSubmitButtonDisabled(false);
      setNewPassword(password);
    } else {
      if (submitButtonDisabled !== true) {
        setSubmitButtonDisabled(true);
      }
    }
  };
  return (
    <>
      <LoginFormHeader heading={t('requireNewPassword.heading')} />

      {errorMessage && (
        <AlertContainer>
          <Alert heading={errorMessage} variation="error" />
        </AlertContainer>
      )}

      <form onSubmit={handleConfirm}>
        <PasswordStrength handleFormChange={handleFormChange} />

        <SubmitContainer>
          <SubmitButtonContainer>
            <Button variation="primary" onClick={handleConfirm} disabled={submitButtonDisabled || isLoading}>
              {t('requireNewPassword.confirmButton')}
            </Button>

            {isLoading && <Spinner />}
          </SubmitButtonContainer>
        </SubmitContainer>

        <SubmitContainer>
          <LinkButton onClick={handleBackToSignIn}>{t('requireNewPassword.returnButton')}</LinkButton>
        </SubmitContainer>
      </form>
    </>
  );
};

export default VerifyUser;
